<template>
    <div class="page">
        <div class="content-box first" v-loading="Loading">
            <div class="page-group-title m-t-4">{{ data.title }}</div>
            <div class="color-info m-t-2">{{ $utils.formatDate(data.pushTime || 0, 'yyyy-MM-dd HH:mm') }}</div>
            <div class="content m-t-4" v-html="data.content"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.content-box {
    .content {
        img {
            max-width: 100%;
        }
    }
}
</style>

<script>
export default {
    name: 'notice',
    components: {},
    data() {
        return {
            data: {},
            Loading: true
        };
    },
    created() {
        this.getNotice();
    },
    mounted() { },
    activated() { },
    deactivated() { },
    methods: {
        //获取列表数据
        getNotice() {
            this.Loading = true;
            this.$request({
                url: '/user/userhome/view/sysnotice_one',
                params: { sysNotifyId: this.$route.params.id },
                method: 'post'
            })
                .then(res => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result || {};
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.Loading = false;
                });
        }
    }
};
</script>
